import {
  OrderDetailData,
  OrderDetailInput,
} from '@/proxy/order/hooks/useOrderDetail/types'
import { QueryOptions } from '@/resources/types'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const ORDER_DETAIL = gql`
  query sellerOrderDetail($number: String!) {
    sellerOrderDetail(number: $number) {
      number
      date
      customer {
        name
        document
        email
        isFirstPurchase
      }
      items {
        name
        amount
        unitPrice
        image
        variantId
        totalPrice
        categoryId
        brandId
        promotion {
          promotionName
          discountId
        }
      }
      delivery {
        deliveryDate {
          startDate
          endDate
        }
        address {
          zip
          city
          street
          number
          province
          neighborhood
          complement
          location {
            type
            coordinates
          }
        }
        code
        type
      }
      payment {
        type
      }
      charging {
        coupon {
          total
          code
          description
        }
        shippingFee
        subTotal
        discount
        cashback
        change
        total
        totalSamplingsPrice
      }
      statusHistories {
        date
        status
        userEmail
        reasons
        statusEvents {
          event {
            key
            value
          }
        }
      }
      status
      expiringTime
      note
      isEditable
      isOrderUpdatedBySeller
      editOptions {
        option
      }
      rating {
        note
        reasons
        value
      }
      serviceFee {
        total
        heavyBagFee {
          isHeavyBag
          value
        }
        baseServiceFee {
          value
        }
      }
      checkoutType
      productChangesHistory {
        originalVariantId
        originalQuantity
        finalQuantity
        replacements {
          finalVariantId
          finalQuantity
        }
      }
    }
  }
`

export const ORDER_DETAIL_QUERY_KEY = 'useOrderDetail'

export const useOrderDetail = (
  variables: OrderDetailInput,
  options: QueryOptions
) =>
  useQuery<OrderDetailData>({
    queryKey: [ORDER_DETAIL_QUERY_KEY, variables],
    queryFn: () => client.request(ORDER_DETAIL, variables),
    ...options,
  })
